export default {
  mounted() {
    this.$store.commit('SET_TU_NIU_CONFIG', true)
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'TuNiuProductList', title: '同步产品' },
      { name: 'TuNiuOrderList', title: '订单列表' },
      { name: 'TuNiuApiConfigure', title: 'API配置' }
    ])
  }
}
